import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterActiveZoneTopicButton',
    props: {
        topic: {}
    },
    emits: ['update:remove'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:remove', _ctx.topic?.id))),
                type: "button",
                class: "filter-newsroom-event__oneFilterButton"
            }, _toDisplayString(_ctx.topic?.tName), 1 /* TEXT */));
        };
    }
});
